import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { href: 'https://clevys.fr/#apropos', label: 'À PROPOS' },
    { href: 'https://clevys.fr/#devis', label: 'DEVIS PHOTO' },
    { href: 'https://clevys.fr/#services', label: 'POUVOIRS' },
    { href: 'https://clevys.fr/#tarifs', label: 'TARIFS' },
    { href: 'https://clevys.fr/#realisations', label: 'RÉALISATIONS' },
    { href: 'https://clevys.fr/#assurances', label: 'ALLIÉS' },
    { href: 'https://clevys.fr/#faq', label: 'AIDE' },
    { href: 'https://clevys.fr/#avis', label: 'FANS' },
    { href: 'https://clevys.fr/blog.html', label: 'BLOG' },
  ];

  return (
    <>
      {/* Top bar */}
      <div className="bg-[#1a1a1a] text-yellow-400 text-xs py-2 px-4 flex flex-wrap items-center justify-center gap-4 font-bold tracking-wide">
        <a href="https://maps.google.com/?q=86+avenue+philippe+auguste+75011+paris" target="_blank" rel="nofollow" className="hover:text-white transition-colors whitespace-nowrap">
          📍 86 AV. PHILIPPE AUGUSTE — 75011 PARIS
        </a>
        <span className="text-yellow-600">✦</span>
        <a href="https://maps.google.com/?q=57+boulevard+jean+jaures+92100+boulogne" target="_blank" rel="nofollow" className="hover:text-white transition-colors whitespace-nowrap">
          📍 57 BD JEAN JAURÈS — 92100 BOULOGNE
        </a>
        <span className="text-yellow-600">✦</span>
        <a href="tel:0660441172" className="hover:text-white transition-colors whitespace-nowrap">📞 06 60 44 11 72</a>
      </div>

      {/* Main nav */}
      <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-[#FFD600]'}`}>
        <div className="max-w-screen-xl mx-auto px-4 flex items-center justify-between h-14">
          <a href="https://clevys.fr/" className={`text-2xl font-black tracking-tighter ${scrolled ? 'text-[#1a1a1a]' : 'text-[#1a1a1a]'}`}>
            🦸 CLEVYS
          </a>

          {/* Desktop links */}
          <ul className="hidden lg:flex items-center gap-5">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-[11px] font-black tracking-widest text-[#1a1a1a] hover:text-red-600 transition-colors whitespace-nowrap"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <a
            href="tel:0660441172"
            className="hidden lg:flex items-center gap-2 bg-red-600 text-white text-xs font-black px-4 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap"
          >
            📞 06 60 44 11 72
          </a>

          {/* Hamburger */}
          <button
            className="lg:hidden w-8 h-8 flex items-center justify-center text-[#1a1a1a]"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="lg:hidden bg-[#FFD600] border-t border-yellow-500 px-4 pb-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="block py-2 text-xs font-black tracking-widest text-[#1a1a1a] hover:text-red-600 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:0660441172"
              className="mt-3 flex items-center justify-center gap-2 bg-red-600 text-white text-xs font-black px-4 py-2 rounded-full"
            >
              📞 06 60 44 11 72
            </a>
          </div>
        )}
      </nav>
    </>
  );
}
